import React from 'react';

export const NewArrowDownIcon = (props) => {
  const { className = '', style = {} } = props;
  return (
    <svg
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
      {...props}
    >
      <g clipPath="url(#clip0_1674_10884)">
        <path
          d="M7.98827 17.1735C8.7003 16.5021 9.79887 16.5225 10.4906 17.2142L13.827 20.5506L13.827 7.71361C13.827 6.71676 14.6204 5.92335 15.6172 5.92335C16.6141 5.92335 17.4075 6.71676 17.4075 7.71361L17.4075 20.5506L20.7439 17.2142C21.4356 16.5225 22.5341 16.5225 23.2462 17.1735C23.9785 17.8652 23.9989 19.0248 23.2868 19.7368L15.6376 27.3861L7.98827 19.7368C7.27623 19.0248 7.29658 17.8652 8.02896 17.1735L7.98827 17.1735Z"
          fill="#005D98"
        />
      </g>
      <defs>
        <clipPath id="clip0_1674_10884">
          <rect width="32" height="32" fill="white" transform="translate(0 0.589966)" />
        </clipPath>
      </defs>
    </svg>
  );
};
